module.exports = __webpack_public_path__ + "static/Banner-8-71847e92b863b2afcdcfeee3e49bd6c8.png";